import RequestStatus from "src/model/RequestStatus";
import {
    ADDITIONAL_INFO_QUERY_SUCCESS,
    GetSelectedProductQueryComplete, SELECTED_PRODUCT_QUERY_FAILED,
    SELECTED_PRODUCT_QUERY_START,
    SELECTED_PRODUCT_QUERY_SUCCESS, SELECTED_PRODUCT_REMOVE, SWITCH_AMAZON_STORE_START_NEW
} from "src/actions/SelectedProductQueryAction";
import {GetSelectedProductResponse, SelectedProductResponse} from "src/model/ProductMatch";
import {AdditionalInfo} from "src/model/AdditionalInfo";

const initialState: GetSelectedProductResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    data: null,
};

export default (
    state: GetSelectedProductResponse = initialState,
    action: GetSelectedProductQueryComplete
): GetSelectedProductResponse => {
    switch (action.type) {
        case SELECTED_PRODUCT_QUERY_START:
            return {
                requestStatus: RequestStatus.LOADING,
                data: null,
            };
        case SELECTED_PRODUCT_QUERY_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                data: action.selectedProductData // TODO: merge fields
            };
        case ADDITIONAL_INFO_QUERY_SUCCESS:
            //selectedProductData is FeaturedOfferResponse
            const featuredOffer: AdditionalInfo = action.selectedProductData.data;
            let productData = state.data;
            productData.selectedProduct.winOfferFulfillerName = featuredOffer.shipsFrom;
            productData.selectedProduct.winOfferMerchantName = featuredOffer.soldBy;
            productData.selectedProduct.winOfferPriceAmount = featuredOffer.price?.amount;
            productData.selectedProduct.winOfferPriceCurrencyCode = featuredOffer.price?.currency;
            productData.selectedProduct.winOfferShippingAmount = featuredOffer.shipping?.amount;
            productData.selectedProduct.winOfferCondition = featuredOffer.condition;
            return {
                requestStatus: RequestStatus.SUCCESS,
                data: productData
            }
        case SELECTED_PRODUCT_QUERY_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                data: null,
            };
        case SELECTED_PRODUCT_REMOVE:
        case SWITCH_AMAZON_STORE_START_NEW:
            return initialState;
        default:
            return state;
    }
};

